module.exports = {"1":"Taxes","2":"Fees","3":"Other","default":"3"}


//////////////////
// WEBPACK FOOTER
// ./src/components/_modules/I2P/models/itemTypes.json
// module id = l2QP
// module chunks = 12